import { BusinessObjectPart, BusinessObjectPartContext, ModelBase, Weaver } from '@skylab-shared/core';
import { ExchangeRateModel } from '@skylab-shared/dataModel';
import { ExchangeRateEqualsOneWarning } from '../violations/exchange-rate-equals-one-warning';
import { ExchangeRateGreaterThanZeroError } from '../violations/exchange-rate-should-be-greater-than-zero-error';
import { ExchangeRateUnitsGreaterThanZeroError } from '../violations/exchange-rate-units-should-be-greater-than-zero-error';


interface DocumentModelPart extends ModelBase {
    documentNumber: string;
    numberingId: number;
}

export class DocumentExchangeRateValidationBoPart extends BusinessObjectPart<DocumentModelPart> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    public override async initializeAsync(context: BusinessObjectPartContext<DocumentModelPart>): Promise<void> {
        await super.initializeAsync(context);

        this.engine.validation.addRule(
            [[ExchangeRateModel, 'rate']],
            ctx => !(ctx.source.rate === 1),
            ExchangeRateEqualsOneWarning
        );

        this.engine.validation.addRule(
            [[ExchangeRateModel, 'rate']],
            ctx => !(ctx.source.rate <= 0),
            ExchangeRateGreaterThanZeroError
        );

        this.engine.validation.addRule(
            [[ExchangeRateModel, 'units']],
            [[ExchangeRateModel, 'rate']],
            ctx => !(ctx.source.units <= 0),
            ExchangeRateUnitsGreaterThanZeroError
        );
    }
}
